module.exports = __webpack_public_path__ + "media/images/donation/payment-image-988183c24ceb803aad8cdb7864b9ec6e.jpg";